import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import {
  FacebookShareButton,
  LinkedinShareButton,
  EmailShareButton,
} from "react-share";

import theme from "../../theme";

import PostBg from "assets/images/single-post-bg.png";
import Arrow from "assets/icons/btn-arrow-pink.svg";

const PageHeader = styled.div`
  width: 100%;
  padding: 20px 0;
  background-image: url(${PostBg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  margin-top: 100px;

  .container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    height: 100%;
    padding: 24px 15px;
  }

  .post-header {
    .row {
      width: 100%;
    }
    &__wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      &-social {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        color: #fff;
        text-transform: uppercase;

        img {
          max-height: 22px;
          margin: 0 0 0 15px;
          transition: all 150ms linear;

          &:hover {
            opacity: 0.75;
          }
        }
      }
    }
  }
`;

const Title = styled.h1`
  font-size: 40px;
  font-weight: 500;
  color: #fff;
  margin: 40px 0;

  ${theme.screens.mdScreen} {
    font-size: 32px;
  }

  ${theme.screens.smScreen} {
    font-size: 28px;
    margin: 25px 0;
  }
`;

const Date = styled.div`
  color: #fff;
  font-size: 14px;
  text-transform: uppercase;

  ${theme.screens.smScreen} {
    font-size: 10px;
  }
`;

const PostHeading = styled.div`
  display: block;
`;

const BackBtn = styled(Link)`
  color: ${theme.colors.pink};
  font-size: 14px;
  position: relative;
  margin-left: 40px;

  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    background-image: url(${Arrow});
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    transform: translate(-35px, -50%) rotate(180deg);
    width: 16px;
    height: 16px;
    transition: all 0.25s ease-in-out;
  }
  ${theme.mixins.onEvent} {
    &:before {
      transform: translate(-40px, -50%) rotate(180deg);
    }
  }
`;

const PostBanner = ({ title, date, className, parentLink = "/news/" }) => {
  const isBrowser = typeof window !== "undefined";
  const location = isBrowser ? window.location.href : null;

  return (
    <PageHeader>
      <div className="post-header">
        <div className="container">
          <BackBtn className={className} to={parentLink}>
            Back
          </BackBtn>
          <PostHeading className={className}>
            {title && <Title dangerouslySetInnerHTML={{ __html: title }} />}
          </PostHeading>
          <div className="row align-items-center g-0">
            <div className="col-lg-6 col-6">
              {date && <Date dangerouslySetInnerHTML={{ __html: date }} />}
            </div>
            <div className="col-lg-4 col-6">
              <div className="post-header__wrapper-social">
                <p>Share</p>
                <FacebookShareButton url={location}>
                  <img
                    src={
                      require("../../assets/icons/post-author-facebook.svg")
                        .default
                    }
                    alt=""
                  />
                </FacebookShareButton>
                <LinkedinShareButton url={location}>
                  <img
                    src={
                      require("../../assets/icons/post-author-linkedin.svg")
                        .default
                    }
                    alt=""
                  />
                </LinkedinShareButton>
                <EmailShareButton url={location}>
                  <img
                    src={
                      require("../../assets/icons/post-author-mail.svg").default
                    }
                    alt=""
                  />
                </EmailShareButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageHeader>
  );
};

export default PostBanner;
